import { request, jsonOptions } from './client';

export const miscApi = {
  activity:        (page = 1) => request(`/activity?page=${page}`),
  reputationLeaderboard: () => request('/leaderboard/reputation'),
  winsLeaderboard:       () => request('/leaderboard/wins'),
  trendingLeaderboard:   () => request('/leaderboard/trending'),
  reputationRewards:     () => request('/reputation/rewards'),
  mediaConfig:           () => request('/media/config'),
  reportReasons:         () => request('/reports/reasons'),
  report:                (payload) => request('/reports', jsonOptions('POST', payload)),
  // Unified search → { query, users, hashtags, battles }.
  search: (q, { type, limit } = {}) => {
    const sp = new URLSearchParams({ q });
    if (type) sp.set('type', type);
    if (limit) sp.set('limit', String(limit));
    return request(`/search?${sp.toString()}`);
  }
};
